import {
  type CustomChatRoomItem,
  type TextChatRoomItem,
  ChatRoomItemType,
  type UnknownChatRoomItem,
  type DocumentChatRoomItem,
  type ImageChatRoomItem,
  type AudioChatRoomItem,
} from "../Domain/Chat";

import { customChatRoomItemTypes, textChatRoomItemTypes } from "../Domain/Chat";

import { hasValue, isObject } from "@/Utils/Objects";
import { isString } from "@/Utils/String";

export abstract class ChatRoomItemTypeGuard {
  static isCustom(value: unknown): value is CustomChatRoomItem {
    return (
      isObject(value) &&
      hasValue(value.type) &&
      customChatRoomItemTypes.includes(value.type as ChatRoomItemType)
    );
  }

  static isText(value: unknown): value is TextChatRoomItem {
    return (
      isObject(value) &&
      hasValue(value.type) &&
      textChatRoomItemTypes.includes(value.type as ChatRoomItemType)
    );
  }

  static isUnknown(value: unknown): value is UnknownChatRoomItem {
    return isObject(value) && hasValue(value.type) && value.type === ChatRoomItemType.UNKNOWN;
  }

  static isNeutralTimeText(value: unknown): value is CustomChatRoomItem {
    return isObject(value) && hasValue(value.type) && value.type === ChatRoomItemType.NEUTRAL_TIME_TEXT;
  }

  static isNeutralTextGrey(value: unknown): value is CustomChatRoomItem {
    return isObject(value) && hasValue(value.type) && value.type === ChatRoomItemType.NEUTRAL_TEXT_GREY;
  }

  static isFile(value: unknown): value is DocumentChatRoomItem {
    return isObject(value) && hasValue(value.fileName) && isString(value.fileName);
  }

  static isImage(value: unknown): value is ImageChatRoomItem {
    return isObject(value) && hasValue(value.thumbnail) && isString(value.thumbnail);
  }

  static isAudio(value: unknown): value is AudioChatRoomItem {
    return isObject(value) && hasValue(value.length) && hasValue(value.size) && hasValue(value.url);
  }
}

export default ChatRoomItemTypeGuard;
